export const APP_SESSION_COOKIE_NAME = 'indiSession';
export const WPSET_DEFAULT = 'ch24_hp_directtypein';
export const BPM_COOKIE_NAME = 'bpm';
